@if (!videoOnly) {
  <nmo-simple-header></nmo-simple-header>
}

@if (!videoOnly) {
  <div class="ad-info">Entgeltliche Einschaltung</div>
}
<!--<app-jwplayer *ngIf="mediaId" [mediaId]="mediaId"></app-jwplayer>-->
@if (mediaId) {
  <app-radiant-player [mediaId]="mediaId"></app-radiant-player>
}

@if (!videoOnly) {
  <nmo-simple-footer></nmo-simple-footer>
}
